import React, { useState, useEffect, useContext } from "react"
import { AppContext } from "../../AppContext";

import UserAccountListComp from "./UserAccountListComp";
import UserAccountCreateComp from "./UserAccountCreateComp";
import UserAccountEditComp from "./UserAccountEditComp";
import UserAccountDeleteComp from "./UserAccountDeleteComp";
import UserAccountDetail from "./UserAccountDetail";

import ErrorComp from "../common/ErrorComp";
import LoadingComp from "../common/LoadingComp";

import { fetchCall } from "../../common/FetchHelpers";
import DateUtil from "../../common/dateUtil";
import {cleanCsvString} from '../../common/Utils';

import { isClient } from "../../common/checkClient";

const UserAccountComp = (props) => {
  const brokerDealerUrl = "api/trade-request/finInstitute";
    
    const [appContext, setAppContext] = useContext(AppContext);
    const isStewardBlackdiamond = isClient('stewardblackdiamond');

    const [metadata, setMetadata] = useState({});
    const [showError, setShowError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [addingAccount, setAddingAccount] = useState(false);
    const [editingAccount, setEditingAccount] = useState(false);
    const [deletingAccount, setDeletingAccount] = useState(false);
    const [showDetailAccount, setShowDetailAccount] = useState(false);
    
    const [selectedAccount, setSelectedAccount] = useState({});
  
    useEffect(() => {

        fetchCall(brokerDealerUrl)
            .then((result)=>{
                setMetadata({ ...metadata, brokerDealer: result });
                setLoading(false);

            },
            (err)=>{
                setLoading(false);
                setShowError(true);

            }
        );
    }, []);

    const onClickAddAccount = () => {
        setAddingAccount(true);
    };

    const onEditClose = () => {
        console.log('Edit closed');
        setEditingAccount(false);
    };

    const onAddClose = () => {
        setAddingAccount(false);
    };


    const onEdit = (item) => {

        const relationOptions = ['Self','Spouse','Joint','Non-Spouse','Partner','Child','Guardian','Trust'];
        if(isStewardBlackdiamond){
            relationOptions.push('Personal Fiduciary/Authorized Agent');
        }

        item.brokerDealerId = item.brokerDealerId||'Other';
        item.accountRegistration = item.accountRegistration||'';
        item.accountType = item.accountType||'';
        
        item.otherBrokerDealerAddress = item.otherBrokerDealerAddress||'';
        item.otherBrokerDealerContact = item.otherBrokerDealerContact||'';

        item.accountOpenDate = item.accountOpenDate?DateUtil.toDate(item.accountOpenDate):null;
        item.otherRelation = item.accountRelation?((relationOptions.includes(item.accountRelation))?'':item.accountRelation):'';
        item.accountRelation = item.accountRelation?((relationOptions.includes(item.accountRelation))?item.accountRelation:'Other'):'';
        item.beneficiaries = item.beneficiaries||'';
        item.beneficiaries = cleanCsvString(item.beneficiaries,'|').split('|');
        setSelectedAccount(item);
        setEditingAccount(true);
    };

    const onDetail = (item) => {
        item.accountOpenDate = item.accountOpenDate?DateUtil.toDate(item.accountOpenDate):null;
        item.beneficiaries = item.beneficiaries||'';
        item.beneficiaries = cleanCsvString(item.beneficiaries,'|').split('|');
        setSelectedAccount(item);
        setShowDetailAccount(true);
    };

    const onDetailClose = ()=>{
        setShowDetailAccount(false);
    };

    const onDelete = (item) => {
        console.log("Deleting", item);
        item.accountOpenDate = item.accountOpenDate?DateUtil.toDate(item.accountOpenDate):null;
        item.beneficiaries = item.beneficiaries||'';
        item.beneficiaries = cleanCsvString(item.beneficiaries,'|').split('|');
        setSelectedAccount(item);
        setDeletingAccount(true);
    };


    const handleDeleteComplete = () => {
        setDeletingAccount(false);
    };

    return (
        <div className={appContext.sidebarCollapsed?"content-wrapper sidebar-collapsed":"content-wrapper"}>
            <section>
                <div className="page-title">User Accounts</div>
                <div className="section-content">
                    <div className="panel">
                        <div className="panel-header">
                            <div className="panel-header-label">My Brokerage & Investment Accounts</div>

                            {!addingAccount && !editingAccount && !deletingAccount && !showError && !loading &&
                                <button id="btnAddAccount" type="button" className="btn btn-primary" onClick={onClickAddAccount}>Add Account</button>
                            }

                        </div>
                        <div className="panel-body-no-bottom">

                            {!addingAccount && !editingAccount && !deletingAccount && !showDetailAccount && <UserAccountListComp metadata={metadata} onEdit={onEdit} onDelete={onDelete} onDetail = {onDetail} />}
                            {addingAccount && <UserAccountCreateComp metadata={metadata} handleClose={onAddClose} />}
                            {editingAccount && <UserAccountEditComp data={selectedAccount} metadata={metadata} handleClose={onEditClose} />}
                            {deletingAccount && <UserAccountDeleteComp data={selectedAccount} handleDeleteComplete={handleDeleteComplete} />}
                            {showDetailAccount && <UserAccountDetail data={selectedAccount} handleClose={(onDetailClose)}/>}


                            {showError && <ErrorComp />}
                            {loading && <LoadingComp />}

                        </div>

                    </div>
                </div>
            </section>
        </div>
    );

};

export default UserAccountComp;